import React from "react"
import LoanOptionCard from "./loan-option-card"
import { dollars, LoanOption, IProduct, LoanCalculations, Incentive, APR_EXPLANATION_LINK } from "@oneethos/shared"
import { ITenant } from "@oneethos/shared"
import './loan-options.scss'

type LoanOptionsProps = {
  loanOptions: LoanOption[]
  formData: any
  financingTenant?: ITenant
  isConsumerView?: boolean
  onProductSelect?: (product: IProduct) => void,
  maxPaymentAmount?: number
  label?: string
  incentive?: Incentive
}

export const LoanOptions = ({
  loanOptions,
  formData,
  financingTenant,
  isConsumerView,
  onProductSelect,
  label,
  incentive: propIncentive,
}: LoanOptionsProps) => {

  const {
    projectType,
    incentive: formDataIncentive
  } = formData

  const incentive = propIncentive || formDataIncentive
  const isResidential = projectType === "residential"

  return (
    <div className="fin-tenant">
      {label && <p>{label}</p>}
      <div className={[`d-flex gap-4 loan-options`, incentive ? 'has-incentive' : ''].filter(Boolean).join(' ')}>
        {loanOptions.map(({ product, payments, apr }) => {
          return (
            <LoanOptionCard
              key={product.id}
              financingTenant={financingTenant}
              incentive={incentive}
              loanTermYears={LoanCalculations.calculateLoanTermInYears(product.term)}
              loanTermMonths={product.term}
              interestWithAutoPay={product.interestRateWithAutopay}
              estimatedPaymentWithAutopay={dollars(payments.withAutoPay)}
              estimatedPaymentWithOutAutopay={dollars(payments.withoutAutoPay)}
              isConsumerView={isConsumerView}
              isSelected={product.id === formData.productId}
              getProduct={() => onProductSelect(product)}
              interestOnlyPeriod={product.interestOnlyPeriod}
              apr={apr}
              isResidential={isResidential}
            />
          )
        })}
      </div>

      {projectType === "residential" && (
        <p className="mt-3 fst-italic">
          *{financingTenant.name} offers a discount to clients that opt into, and maintain,
          automatic monthly payments. The bill amount will automatically be withdrawn
          from the client's checking account.
        </p>
      )}
      <a
        href={APR_EXPLANATION_LINK}
        className="text-small d-flex mb-3 fst-italic"
        target="_blank"
      >**How is APR different from interest rate?</a>
    </div>
  )
}

export default LoanOptions
